import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { Analytics } from '@vercel/analytics/react';
import { Suspense, lazy } from 'react';
import { AuthProvider } from './hooks/useAuth';
import ScrollToTop from './components/ScrollToTop';
import ProtectedRoute from './components/ProtectedRoute';

// Lazy load components for performance
const LandingPage = lazy(() => import('./pages/LandingPage'));
const Login = lazy(() => import('./pages/Login'));
const Signup = lazy(() => import('./pages/Signup'));
const AdminDashboard = lazy(() => import('./pages/AdminDashboard'));
const UserDashboard = lazy(() => import('./pages/UserDashboard'));
const SessionBooking = lazy(() => import('./pages/SessionBooking'));
const Profile = lazy(() => import('./pages/Profile'));
const Unauthorized = lazy(() => import('./pages/Unauthorized'));
const RescheduleBooking = lazy(() => import('./pages/RescheduleBooking'));
const BookACall = lazy(() => import('./pages/BookACall'));
const Simulation = lazy(() => import('./pages/Simulation'));
const Article = lazy(() => import('./pages/Article'));
const ArticlesList = lazy(() => import('./pages/ArticlesList'));

function PageLoader() {
  return (
    <div className="min-h-screen bg-charcoal-950 flex items-center justify-center">
      <div className="h-8 w-8 rounded-full border-2 border-accent-blue/30 border-t-accent-blue animate-spin" />
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <div className="min-h-screen bg-charcoal-900 text-white">
        <Router>
          <ScrollToTop />
          <Toaster position="top-left" theme="dark" richColors />
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/book" element={<BookACall />} />
              <Route path="/simulation" element={<Simulation />} />
              <Route path="/articles" element={<ArticlesList />} />
              <Route path="/articles/:slug" element={<Article />} />
              <Route path="/sessions/:slug" element={<SessionBooking />} />
              <Route path="/unauthorized" element={<Unauthorized />} />
              
              {/* Protected Routes */}
              <Route 
                path="/admin" 
                element={
                  <ProtectedRoute allowedRoles={['admin']}>
                    <AdminDashboard />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/profile" 
                element={
                  <ProtectedRoute allowedRoles={['admin', 'user']}>
                    <Profile />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/dashboard" 
                element={
                  <ProtectedRoute allowedRoles={['admin', 'user']}>
                    <UserDashboard />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/booking/reschedule/:bookingId" 
                element={
                  <ProtectedRoute allowedRoles={['admin', 'user']}>
                    <RescheduleBooking />
                  </ProtectedRoute>
                } 
              />
            </Routes>
          </Suspense>
          <Analytics />
        </Router>
      </div>
    </AuthProvider>
  );
}
